import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
// eslint-disable-next-line no-restricted-imports
import NextLink, { type LinkProps } from 'next/link';
import { usePathname } from 'next/navigation';
import type { AnchorHTMLAttributes, PropsWithChildren } from 'react';
import { docsBaseUrl } from '@/contexts/environment';
import { useViewParameters } from '@/contexts/navigation';
import { serialize } from '@/contexts/navigation/serialization';
export interface GeneralLinkProps extends PropsWithChildren<LinkProps>, Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  disabled?: boolean;
}
export const Link = props => {
  const $ = _c(10);
  let t0;
  if ($[0] !== props.href) {
    t0 = typeof props.href === "string" && props.href.startsWith(docsBaseUrl) ? {
      prefetch: false
    } : {};
    $[0] = props.href;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const disablePrefetchProps = t0;
  const t1 = props.className ? props.className : "";
  let t2;
  if ($[2] !== props.disabled || $[3] !== t1) {
    t2 = classNames(t1, {
      "pointer-events-none": props.disabled
    });
    $[2] = props.disabled;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = props.disabled ? -1 : undefined;
  let t4;
  if ($[5] !== disablePrefetchProps || $[6] !== props || $[7] !== t2 || $[8] !== t3) {
    t4 = <NextLink {...disablePrefetchProps} {...props} className={t2} aria-disabled={props.disabled} tabIndex={t3}>{props.children}</NextLink>;
    $[5] = disablePrefetchProps;
    $[6] = props;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
type NavigationLinkProps = Omit<GeneralLinkProps, 'href'> & {
  path: string;
  searchParams?: Record<string, unknown>;
};
export const NavigationLink = props => {
  const $ = _c(14);
  let path;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      path,
      searchParams: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = path;
    $[2] = rest;
    $[3] = t0;
  } else {
    path = $[1];
    rest = $[2];
    t0 = $[3];
  }
  const searchParams = t0 === undefined ? {} : t0;
  const {
    getAll,
    setParams
  } = useViewParameters();
  const currentPath = usePathname();
  const hasSearchParams = Object.keys(searchParams).length > 0;
  let url = path;
  if (hasSearchParams) {
    const {
      pageIndex,
      ...currentParams
    } = getAll();
    const params = path === currentPath ? {
      ...Object.entries(currentParams).reduce(_temp, {}),
      ...searchParams
    } : searchParams;
    url = url + `?${new URLSearchParams(serialize(params))}`;
  }
  let t1;
  if ($[4] !== currentPath || $[5] !== hasSearchParams || $[6] !== path || $[7] !== searchParams || $[8] !== setParams) {
    t1 = () => {
      if (hasSearchParams && path === currentPath) {
        setParams(state => ({
          ...state,
          ...searchParams
        }));
      }
    };
    $[4] = currentPath;
    $[5] = hasSearchParams;
    $[6] = path;
    $[7] = searchParams;
    $[8] = setParams;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== rest || $[11] !== t1 || $[12] !== url) {
    t2 = <Link {...rest} href={url} onClick={t1} />;
    $[10] = rest;
    $[11] = t1;
    $[12] = url;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};
function _temp(acc, t0) {
  const [key, value] = t0;
  acc[key] = key === "pageIndex" ? 0 : value;
  return acc;
}